// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Dashboard components
import StudentHomework from "pages/dashboard/components/StudentHomework";

function StudentDashboard() {
  return (
    <>
      <MDBox pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <StudentHomework />
          </Grid>
          {/*<Grid item xs={12} md={4} lg={4}>*/}
          {/*  /!*<OrdersOverview />*!/*/}
          {/*  <MDBox my={1.5}>*/}
          {/*    <ComplexStatisticsCard*/}
          {/*      color="dark"*/}
          {/*      icon="weekend"*/}
          {/*      title="Bookings"*/}
          {/*      count={281}*/}
          {/*      percentage={{*/}
          {/*        color: "success",*/}
          {/*        amount: "+55%",*/}
          {/*        label: "than lask week",*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </MDBox>*/}
          {/*  <MDBox my={3}>*/}
          {/*    <ComplexStatisticsCard*/}
          {/*      color="dark"*/}
          {/*      icon="weekend"*/}
          {/*      title="Bookings"*/}
          {/*      count={281}*/}
          {/*      percentage={{*/}
          {/*        color: "success",*/}
          {/*        amount: "+55%",*/}
          {/*        label: "than lask week",*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </MDBox>*/}
          {/*  <MDBox my={3}>*/}
          {/*    <ComplexStatisticsCard*/}
          {/*      color="dark"*/}
          {/*      icon="weekend"*/}
          {/*      title="Bookings"*/}
          {/*      count={281}*/}
          {/*      percentage={{*/}
          {/*        color: "success",*/}
          {/*        amount: "+55%",*/}
          {/*        label: "than lask week",*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </MDBox>*/}
          {/*</Grid>*/}
        </Grid>
      </MDBox>
      {/*<MDBox py={3}>*/}
      {/*  <Grid container spacing={3}>*/}
      {/*    <Grid item xs={12} md={6} lg={3}>*/}
      {/*      <MDBox mb={1.5}>*/}
      {/*        <ComplexStatisticsCard*/}
      {/*          color="dark"*/}
      {/*          icon="weekend"*/}
      {/*          title="Bookings"*/}
      {/*          count={281}*/}
      {/*          percentage={{*/}
      {/*            color: "success",*/}
      {/*            amount: "+55%",*/}
      {/*            label: "than lask week",*/}
      {/*          }}*/}
      {/*        />*/}
      {/*      </MDBox>*/}
      {/*    </Grid>*/}
      {/*    <Grid item xs={12} md={6} lg={3}>*/}
      {/*      <MDBox mb={1.5}>*/}
      {/*        <ComplexStatisticsCard*/}
      {/*          icon="leaderboard"*/}
      {/*          title="Today's Users"*/}
      {/*          count="2,300"*/}
      {/*          percentage={{*/}
      {/*            color: "success",*/}
      {/*            amount: "+3%",*/}
      {/*            label: "than last month",*/}
      {/*          }}*/}
      {/*        />*/}
      {/*      </MDBox>*/}
      {/*    </Grid>*/}
      {/*    <Grid item xs={12} md={6} lg={3}>*/}
      {/*      <MDBox mb={1.5}>*/}
      {/*        <ComplexStatisticsCard*/}
      {/*          color="success"*/}
      {/*          icon="store"*/}
      {/*          title="Revenue"*/}
      {/*          count="34k"*/}
      {/*          percentage={{*/}
      {/*            color: "success",*/}
      {/*            amount: "+1%",*/}
      {/*            label: "than yesterday",*/}
      {/*          }}*/}
      {/*        />*/}
      {/*      </MDBox>*/}
      {/*    </Grid>*/}
      {/*    <Grid item xs={12} md={6} lg={3}>*/}
      {/*      <MDBox mb={1.5}>*/}
      {/*        <ComplexStatisticsCard*/}
      {/*          color="primary"*/}
      {/*          icon="person_add"*/}
      {/*          title="Followers"*/}
      {/*          count="+91"*/}
      {/*          percentage={{*/}
      {/*            color: "success",*/}
      {/*            amount: "",*/}
      {/*            label: "Just updated",*/}
      {/*          }}*/}
      {/*        />*/}
      {/*      </MDBox>*/}
      {/*    </Grid>*/}
      {/*  </Grid>*/}
      {/*  <MDBox mt={4.5}>*/}
      {/*    <Grid container spacing={3}>*/}
      {/*      <Grid item xs={12} md={6} lg={4}>*/}
      {/*        <MDBox mb={3}>*/}
      {/*          /!*<ReportsBarChart*!/*/}
      {/*          /!*  color="info"*!/*/}
      {/*          /!*  title="website views"*!/*/}
      {/*          /!*  description="Last Campaign Performance"*!/*/}
      {/*          /!*  date="campaign sent 2 days ago"*!/*/}
      {/*          /!*  chart={reportsBarChartData}*!/*/}
      {/*          /!* />*!/*/}
      {/*        </MDBox>*/}
      {/*      </Grid>*/}
      {/*      <Grid item xs={12} md={6} lg={4}>*/}
      {/*        <MDBox mb={3}>*/}
      {/*          /!*<ReportsLineChart*!/*/}
      {/*          /!*  color="success"*!/*/}
      {/*          /!*  title="daily sales"*!/*/}
      {/*          /!*  description={*!/*/}
      {/*          /!*    <>*!/*/}
      {/*          /!*      (<strong>+15%</strong>) increase in today sales.*!/*/}
      {/*          /!*    </>*!/*/}
      {/*          /!*  }*!/*/}
      {/*          /!*  date="updated 4 min ago"*!/*/}
      {/*          /!*  chart={sales}*!/*/}
      {/*          /!* />*!/*/}
      {/*        </MDBox>*/}
      {/*      </Grid>*/}
      {/*      <Grid item xs={12} md={6} lg={4}>*/}
      {/*        <MDBox mb={3}>*/}
      {/*          /!*<ReportsLineChart*!/*/}
      {/*          /!*  color="dark"*!/*/}
      {/*          /!*  title="completed tasks"*!/*/}
      {/*          /!*  description="Last Campaign Performance"*!/*/}
      {/*          /!*  date="just updated"*!/*/}
      {/*          /!*  chart={tasks}*!/*/}
      {/*          /!* />*!/*/}
      {/*        </MDBox>*/}
      {/*      </Grid>*/}
      {/*    </Grid>*/}
      {/*  </MDBox>*/}
      {/*</MDBox>*/}
    </>
  );
}

export default StudentDashboard;
